import { Routes, Route, Link } from "react-router-dom";
import ProtectedRoute from "../rotes/ProtectedRoute";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import PortraitPage from "../pages/PortraitPage";
import CandidatesPage from "../pages/CandidatesPage";
import CandidateSyncIssuesPage from "../pages/CandidateSyncIssuesPage";
import UnlinkedTestResultsPage from "../pages/UnlinkedTestResultsPage";
import RecruitingAutopilotPage from "../pages/RecruitingAutopilotPage";
import CandidateDocumentsPage from "../pages/CandidateDocumentsPage";
import CandidateDocumentsUploadPage from "../pages/CandidateDocumentsUploadPage";
import EmployeeContractsPage from "../pages/EmployeeContractsPage";
import EmployeePage from "../pages/UnifiedEmployeePage";
import EmployeeDetailPage from "../pages/EmployeeDetailPage";
import EmployeeExcelPage from "../pages/EmployeeExcelPage";
import EmployeeAccessPage from "../pages/EmployeeAccessPage";
import OrgChartPage from "../pages/OrgChartPage"; // правка №9: структура как в Битрикс24 (старая сетка OrganizationPage больше не используется)
import DepartmentDetailPage from "../pages/DepartmentDetailPage";
import VacanciesPage from "../pages/VacanciesPage";
import ColdSearchPage from "../pages/ColdSearchPage";
import VacancyTestsPage from "../pages/VacancyTestsPage";
import EventsPlannerPage from "../pages/EventsPlannerPage";
import AnalyticsPage from "../pages/AnalyticsPage";
import TestsPage from "../pages/TestsPage";
import TestEditorPage from "../pages/TestEditorPage";
import PsychResultsPage from "../pages/PsychResultsPage";
import PsychTakePage from "../pages/PsychTakePage";
import ProfessionalTakePage from "../pages/ProfessionalTakePage";
import DepartmentProfilesPage from "../pages/DepartamentProfilesPage";
import Unauthorized from "../pages/Unauthorized";
import CalendarPage from "../pages/CalendarPage";
import BlacklistPage from "../pages/BlacklistPage";
import ArchiveCandidatesPage from "../pages/ArchiveCandidatesPage";
import RequestsPage from "../pages/RequestsPage";
import HiringRequestPublicPage from "../pages/HiringRequestPublicPage";
import ProfilePage from "../pages/ProfilePage";
import ContactsPage from "../pages/ContactsPage";
import CallsPage from "../pages/CallsPage";
import AdaptationPage from "../pages/AdaptationPage";
import AdaptationDetailPage from "../pages/AdaptationDetailPage";
import AdaptationCasePage from "../pages/AdaptationCasePage";
import AdaptationPublicFormPage from "../pages/AdaptationPublicFormPage";
import AdaptationBuilderPage from "../pages/AdaptationBuilderPage";
import AdaptationDashboardPage from "../pages/AdaptationDashboardPage";
import LogsPage from "../pages/LogsPage";
import NotificationsPage from "../pages/NotificationsPage";
import LearningPage from "../pages/LearningPage";
import LearningPublicPage from "../pages/LearningPublicPage";
import AiAssistantPage from "../pages/AiAssistantPage";
import KpiPage from "../pages/KpiPage";
import KpiMonthPage from "../pages/KpiMonthPage";
import KpiSettingsPage from "../pages/KpiSettingsPage";
import CompanyPage from "../pages/CompanyPage";
import { rolesForPath, defaultPathForRole } from "../config/navConfig";
import { useAuth } from "../context/AuthContext";
// Правка №5 (Чат 2): личное меню и стартовая страница. Не удалять при разрешении конфликтов — см. ошибку О1 / конфликт К1.
import { useMenuPrefs } from "../context/MenuPrefsContext";
import StartRedirect from "./StartRedirect";
import MenuSettingsPage from "../pages/MenuSettingsPage";

function NotFound() {
    const { user } = useAuth();
    const { prefs } = useMenuPrefs();
    const home = defaultPathForRole(user?.role, prefs);
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-yellow-50 p-6">
            <h1 className="text-3xl font-bold mb-2">404</h1>
            <p className="text-gray-600 mb-4">Страница не найдена</p>
            <Link to={home} className="px-4 py-2 bg-[#e0bb48] text-black rounded font-medium">
                На главную
            </Link>
        </div>
    );
}

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/take/test/:testId" element={<ProfessionalTakePage />} />
            <Route path="/take/:instrumentId" element={<PsychTakePage />} />
            <Route path="/adaptation/forms/:token" element={<AdaptationPublicFormPage />} />
            <Route path="/candidate-documents/:token" element={<CandidateDocumentsUploadPage />} />
            <Route path="/hiring-request/:token" element={<HiringRequestPublicPage />} />
            <Route path="/learn/:token" element={<LearningPublicPage />} />

            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute roles={rolesForPath("/dashboard")}>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/ai-assistant"
                element={
                    <ProtectedRoute roles={rolesForPath("/ai-assistant")}>
                        <AiAssistantPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/candidate-portrait"
                element={
                    <ProtectedRoute roles={rolesForPath("/candidate-portrait")}>
                        <PortraitPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/candidates"
                element={
                    <ProtectedRoute roles={rolesForPath("/candidates")}>
                        <CandidatesPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/candidates/sync-issues"
                element={
                    <ProtectedRoute roles={rolesForPath("/candidates/sync-issues")}>
                        <CandidateSyncIssuesPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/employees"
                element={
                    <ProtectedRoute roles={rolesForPath("/employees")}>
                        <EmployeePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/employees/excel"
                element={
                    <ProtectedRoute roles={rolesForPath("/employees/excel")}>
                        <EmployeeExcelPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/employees/access"
                element={
                    <ProtectedRoute roles={rolesForPath("/employees/access")}>
                        <EmployeeAccessPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/vacancies"
                element={
                    <ProtectedRoute roles={rolesForPath("/vacancies")}>
                        <VacanciesPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/vacancies/:vacancyId/cold-search"
                element={
                    <ProtectedRoute roles={rolesForPath("/vacancies/:vacancyId/cold-search")}>
                        <ColdSearchPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/vacancies/:vacancyId/tests"
                element={
                    <ProtectedRoute roles={rolesForPath("/vacancies/:vacancyId/tests")}>
                        <VacancyTestsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/events"
                element={
                    <ProtectedRoute roles={rolesForPath("/events")}>
                        <EventsPlannerPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/calls"
                element={
                    <ProtectedRoute roles={rolesForPath("/calls")}>
                        <CallsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/analytics"
                element={
                    <ProtectedRoute roles={rolesForPath("/analytics")}>
                        <AnalyticsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests")}>
                        <TestsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/new"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/new")}>
                        <TestEditorPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/:testId/edit"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/new")}>
                        <TestEditorPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/autopilot"
                element={
                    <ProtectedRoute roles={rolesForPath("/autopilot")}>
                        <RecruitingAutopilotPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/unlinked"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/unlinked")}>
                        <UnlinkedTestResultsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/results"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/results")}>
                        <PsychResultsPage />
                    </ProtectedRoute>
                }
            />

            {/* [Claude] 2026-11-02 — конструктор и дашборд адаптации, только HR (Чат 3, №7) */}
            <Route
                path="/tests/adaptation/builder"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests")}>
                        <AdaptationBuilderPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/tests/adaptation/dashboard"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests")}>
                        <AdaptationDashboardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/tests/adaptation"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/adaptation")}>
                        <AdaptationPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/adaptation/case/:enrollmentId"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/adaptation")}>
                        <AdaptationCasePage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tests/adaptation/:checkpointId"
                element={
                    <ProtectedRoute roles={rolesForPath("/tests/adaptation")}>
                        <AdaptationDetailPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/departments"
                element={
                    <ProtectedRoute roles={rolesForPath("/departments")}>
                        <DepartmentProfilesPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/calendar"
                element={
                    <ProtectedRoute roles={rolesForPath("/calendar")}>
                        <CalendarPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/blacklist"
                element={
                    <ProtectedRoute roles={rolesForPath("/blacklist")}>
                        <BlacklistPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/archive"
                element={
                    <ProtectedRoute roles={rolesForPath("/archive")}>
                        <ArchiveCandidatesPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/requests"
                element={
                    <ProtectedRoute roles={rolesForPath("/requests")}>
                        <RequestsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/contacts"
                element={
                    <ProtectedRoute roles={rolesForPath("/contacts")}>
                        <ContactsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/logs"
                element={
                    <ProtectedRoute roles={rolesForPath("/logs")}>
                        <LogsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/notifications"
                element={
                    <ProtectedRoute roles={rolesForPath("/notifications")}>
                        <NotificationsPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/candidate-documents"
                element={
                    <ProtectedRoute roles={rolesForPath("/candidate-documents")}>
                        <CandidateDocumentsPage />
                    </ProtectedRoute>
                }
            />
            <Route path="/employee-contracts" element={<ProtectedRoute roles={rolesForPath("/employee-contracts")}><EmployeeContractsPage /></ProtectedRoute>} />
            <Route path="/learning" element={<ProtectedRoute roles={rolesForPath("/learning")}><LearningPage /></ProtectedRoute>} />
            <Route path="/employees/:employeeId" element={<ProtectedRoute roles={rolesForPath("/employees")}><EmployeeDetailPage /></ProtectedRoute>} />
            <Route path="/organization" element={<ProtectedRoute roles={rolesForPath("/organization")}><OrgChartPage /></ProtectedRoute>} />
            <Route path="/organization/departments/:departmentId" element={<ProtectedRoute roles={rolesForPath("/organization")}><DepartmentDetailPage /></ProtectedRoute>} />

            <Route
                path="/profile"
                element={
                    <ProtectedRoute roles={rolesForPath("/profile")}>
                        <ProfilePage />
                    </ProtectedRoute>
                }
            />

            {/* KPI (КПЭ) — правка №10, Чат 6 [Claude] 2026-11-02 */}
            <Route path="/kpi" element={<ProtectedRoute roles={rolesForPath("/kpi")}><KpiPage /></ProtectedRoute>} />
            <Route path="/kpi/months/:monthId" element={<ProtectedRoute roles={rolesForPath("/kpi/months")}><KpiMonthPage /></ProtectedRoute>} />
            <Route path="/kpi/settings" element={<ProtectedRoute roles={rolesForPath("/kpi")}><KpiSettingsPage /></ProtectedRoute>} />
            <Route path="/company" element={<ProtectedRoute roles={rolesForPath("/company")}><CompanyPage /></ProtectedRoute>} />

            {/* Правка №5 (Чат 2): после входа Login ведёт на /start — без этого маршрута вход заканчивается 404 (О1). */}
            <Route path="/start" element={<StartRedirect />} />
            <Route
                path="/settings/menu"
                element={
                    <ProtectedRoute roles={rolesForPath("/settings/menu")}>
                        <MenuSettingsPage />
                    </ProtectedRoute>
                }
            />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
